import { Swal } from '@/plugins/sweetalert2'
import { HighlightFormInvalid } from './highlight_form_invalid'
import lang from '@/plugins/lang'

let handlerFormInvalid = new HighlightFormInvalid()

class FetchApiError extends Error {
    constructor(message, status, data) {
        super(message);
        this.name = 'Error fetching API Server'
        this.code = 'error-fetch-api'
        this.data = data
        this.status = status
    }
}

export function handleNetworkIssues(error) {
    error.status = 0

    throw error
}

/**
 * Verifica se a mensagem de erro está presente em um objeto de chaves de tradução.
 *
 * @param {string} errorMessage - A mensagem de erro recebida.
 * @param {Object} translationKeys - O objeto de chaves de tradução.
 * @returns {boolean} - Retorna true se a mensagem de erro corresponder a qualquer tradução, caso contrário false.
 */
function isErrorEqualToTranslation(errorMessage, translationKeys) {
    return Object.values(translationKeys).some(key => errorMessage === lang.t(key))
}

export function handleErrors(error, ignoreCode, form) {
    if (
        ignoreCode === '*' 
        ||  (Array.isArray(ignoreCode) && ignoreCode.includes(error.status))
        ||  ignoreCode === error.status
    ) {
        throw new FetchApiError(error.statusText, error.status, error.data)
    }

    let title
    let type = 'error'
    let customIcon = null
    let fireModal = true

    const translationKeys = {
        invalid_value: 'error_http:error_asaas_payment.invalid_value',
        invalid_billingType: 'error_http:error_asaas_payment.invalid_billingType'
    }

    switch(error.status) {
        case 0:
            title = lang.t('error_http:without_connection.title')
            error.statusText = lang.t('error_http:without_connection.message')
            type = null
            customIcon = '<i class="fa-regular fa-wifi-slash text-danger"></i>'
            break;

        case 400:
            type = 'warning'
            title = isErrorEqualToTranslation(error.data.message, translationKeys) === true ? lang.t('error_http:warning_title') : lang.t('error_http:error_title')
            error.statusText = error.data?.message || lang.t('error_http:400')
            break

        case 401:
            type = 'warning'
            title = lang.t('error_http:warning_title')
            error.statusText = lang.t('error_http:401')
            break

        case 403:
            type = 'warning'
            title = lang.t('error_http:warning_title')
            error.statusText = error.data.message
            break

        case 404:
            title = lang.t('error_http:warning_title')
            error.statusText = error.data.message === 'Not Found'
                ? lang.t('error_http:404')
                : error.data.message
            break

        case 409:
            type = 'warning'
            title = lang.t('error_http:action_not_done')
            error.statusText = error.data.message
            break

        case 419:
            type = 'warning'
            title = lang.t('error_http:action_not_done')
            error.statusText = lang.t('error_http:419')
            break

        case 422:
            let inputErrors = error.data.errors

            if (form) {
                handlerFormInvalid.highlightForm(inputErrors, form)
            }

            if (typeof inputErrors === 'string') {
                type = 'warning'
                title = lang.t('error_http:warning_title')
                error.statusText = inputErrors
            } else {
                fireModal = false
                error.statusText = error.data.message
            }

            break

        case 423:
            error.statusText = error.data.message
            break

        case 429:
            type = 'warning'
            title = lang.t('error_http:warning_title')
            error.statusText = lang.t('error_http:429')
            break

        case 503:
            type = 'warning'
            title = lang.t('error_http:maintenance.title')
            error.statusText = lang.t('error_http:maintenance.message')
            break

        default:
            title = lang.t('error_http:unexpected.title')
            error.statusText = lang.t('error_http:unexpected.message')
            break
    }

    if (fireModal) {
        Swal.fire({
            title,
            text: error.statusText,
            icon: type,
            iconHtml: customIcon,
            customClass: {
                icon: customIcon ? 'border-0' : ''
            }
        })
    }

    throw new FetchApiError(error.statusText, error.status, error.data)
}
